export const SECURITY_ROLE_KEY = {
  User: 'SECURITY_ROLE_USER',
  Assessor: 'SECURITY_ROLE_ASSESSOR',
  Admin: 'SECURITY_ROLE_ADMIN',
  Superuser: 'SECURITY_ROLE_SUPERUSER',
  JobRolePeople: 'SECURITY_ROLE_JOB_PEOPLE',
  JobRoleReqs: 'SECURITY_ROLE_JOB_REQS',
  JobRoleReqsPeople: 'SECURITY_ROLE_JOB_REQS_PEOPLE',
  OuResponsible: 'SECURITY_ROLE_OU_RESPONSIBLE',
  TrainingCalendarAdmin: 'SECURITY_ROLE_TRAINING_CALENDAR_ADMIN', //TBD
} as const satisfies Record<string, string>;

export type SecurityRoleKey =
  (typeof SECURITY_ROLE_KEY)[keyof typeof SECURITY_ROLE_KEY];
